









































































import { Component, Vue } from "vue-property-decorator";
import { authApi, login } from "@/getinfo-api/auth";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import api from "@/getinfo-api";
import CustomButton from "@/components/form/CustomButton.vue";
import { setAuthTokens } from "axios-jwt";
import { getCurrentUserId } from "@/plugins/roles";
import { UserHelperClass } from "@/utils/UserHelperClass";

@Component({
  components: { CustomButton }
})
export default class Login extends Vue {
  private username: string = "";
  private password: string = "";
  private spinnerHide: boolean = true;
  changingPassword: boolean = false;
  isSavingProcess: boolean = false;
  showPassword: boolean = false;
  passwordFieldType = "password";

  public _login() {
    this.spinnerHide = false;
    login({
      username: this.username.trim(),
      password: this.password.trim()
    })
      .then(async data => {
        let _path: any = this.$route?.query?.redirect ?? "/";
        this.$router.push({ path: _path });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.spinnerHide = true;
      });
  }

  get userId() {
    return getCurrentUserId();
  }

  async login() {
    if (!this.username || !this.password) {
      await this.$store.dispatch(
        "localError",
        this.$t(this.$translate.RequiredData)
      );
      return;
    }
    try {
      this.spinnerHide = false;

      const tokenResponse = await authApi.getJWT({
        username: this.username.trim(),
        password: this.password.trim()
      });

      await setAuthTokens({
        accessToken: tokenResponse.data.token,
        refreshToken: tokenResponse.data.refresh_token
      });

      let _path: any = this.$route?.query?.redirect ?? "/";

      this.$store.state.user.user = new UserHelperClass(this.userId);

      await this.$router.push({ path: _path });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.spinnerHide = true;
    }
  }

  togglePasswordView() {
    this.showPassword = !this.showPassword;
    if (this.passwordFieldType === "password") {
      this.passwordFieldType = "text";
    } else {
      this.passwordFieldType = "password";
    }
  }

  _resetPassword() {
    this.changingPassword
      ? (this.changingPassword = false)
      : (this.changingPassword = true);
  }

  startResetPassword() {
    this.isSavingProcess = true;
    api.UsersApi.resetPassword({ usernameOrEmail: this.username })
      .then(() => {
        this.$bvToast.toast(
          `${this.$tc(
            this.$translate.TheLinkToChangeYourPasswordWasSentToTheEmail
          )}`,
          {
            variant: "success",
            title: `${this.$tc(this.$translate.Success)}`
          }
        );
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSavingProcess = false;
      });
  }

  mounted() {
    this.$store.dispatch("clearStore");
    this.$store.commit("homepage/listenerPage/CLEAR");
    this.$store.commit("webinars/CLEAR");
    this.$store.commit("records/CLEAR");
    this.$store.commit("clearCompanyStore");
    this.$store.state.user.user.destroy();
  }
}
